import { Input, Select, Button } from 'antd/lib';
import { Form } from '@ant-design/compatible';

import React from 'react';

import _ from 'lodash';
import Loading from '../Loading';
const { Option } = Select;

class FormDatosEmail extends React.Component {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSubmit(values);
      }
    });
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  crearOpciones(organismo) {
    return (
      <Option key={organismo._id} value={organismo.email}>
        {organismo.nombre}
      </Option>
    );
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    const listaOrganismos = this.props.organismos;
    if (listaOrganismos) {
      var opcionesOrganismos = _.map(listaOrganismos, organismo => {
        if (organismo.email) {
          return this.crearOpciones(organismo);
        }
      });
    }

    if (this.props.enviandoEmail) {
      return <Loading />;
    }

    return (
      <Form {...formItemLayout} onSubmit={this.handleSubmit}>
        <Form.Item label="Organismo Destino">
          {getFieldDecorator('emailDestino', {
            rules: [
              {
                required: true,
                message: 'Por favor, selecciona el organismo destino.',
              },
            ],
          })(
            <Select placeholder="Seleccionar Organismo">
              {opcionesOrganismos}
            </Select>
          )}
        </Form.Item>
        <Form.Item label="Mensaje adicional">
          {getFieldDecorator('cuerpo')(<Input.TextArea rows={4} />)}
        </Form.Item>
        <Form.Item {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">
            Enviar
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

export default Form.create()(FormDatosEmail);
